import { AosrAct, Ks6aEntry } from '../types';

export function exportAosrToDocx(act: AosrAct, project?: any, materials: any[] = []): void {
  const materialsListHtml = materials.length > 0
    ? materials.map((m, idx) => `${idx + 1}. ${m.name || m.title || 'Материал'} (${m.specification || 'ГОСТ'}), Сертификат: ${m.cert_number || m.certNumber || '№ RU C-RU.АБ29'}`).join('<br>')
    : '1. Кабель силовой ВВГнг(А)-LS 3х2.5 кв.мм (ГОСТ 31996-2012, Сертификат соответствия № RU C-RU.АБ29.В.00123/24)<br>2. Труба гибкая гофрированная ПВХ d20мм';

  const docContent = `
<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>
<head>
  <meta charset="utf-8">
  <title>АКТ АОСР ${act.actNumber}</title>
  <!--[if gte mso 9]>
  <xml>
    <w:WordDocument>
      <w:View>Print</w:View>
      <w:Zoom>100</w:Zoom>
      <w:DoNotOptimizeForBrowser/>
    </w:WordDocument>
  </xml>
  <![endif]-->
  <style>
    @page {
      size: A4 portrait;
      margin: 20mm 15mm 20mm 25mm;
    }
    body {
      font-family: 'Times New Roman', serif;
      font-size: 12pt;
      line-height: 1.25;
      color: #000000;
    }
    .text-center { text-align: center; }
    .text-right { text-align: right; }
    .font-bold { font-weight: bold; }
    .header-doc { text-align: center; font-weight: bold; font-size: 14pt; margin-bottom: 12pt; text-transform: uppercase; }
    .sub-doc { text-align: right; font-size: 10pt; margin-bottom: 15pt; font-style: italic; }
    .meta-table { width: 100%; border-collapse: collapse; margin-bottom: 15pt; }
    .meta-table td { padding: 4pt 6pt; vertical-align: top; font-size: 11pt; border: none; }
    .meta-label { font-weight: bold; width: 38%; }
    .section-title { font-weight: bold; margin-top: 12pt; margin-bottom: 4pt; font-size: 12pt; }
    .field-box { border-bottom: 1px solid #000000; padding: 3pt 6pt; margin-bottom: 6pt; min-height: 18pt; }
    .signatures { margin-top: 30pt; width: 100%; border-collapse: collapse; }
    .signatures td { width: 50%; padding: 10pt; vertical-align: top; border: none; }
    .sign-line { border-bottom: 1px solid #000000; margin-top: 25pt; width: 90%; }
    .sign-caption { font-size: 8pt; text-align: center; color: #555555; margin-top: 2pt; width: 90%; }
  </style>
</head>
<body>
  <div class="sub-doc">Приложение № 3 к РД-11-02-2006</div>

  <div class="header-doc">
    АКТ<br>
    ОСВИДЕТЕЛЬСТВОВАНИЯ СКРЫТЫХ РАБОТ<br>
    № ${act.actNumber}
  </div>

  <table class="meta-table">
    <tr>
      <td class="meta-label">Объект капитального строительства:</td>
      <td><strong>${project?.name || act.project_name || 'ЖК «Северная Звезда»'}</strong>, ${project?.address || 'г. Москва, ул. Полярная, д. 42'}</td>
    </tr>
    <tr>
      <td class="meta-label">Застройщик (технический заказчик):</td>
      <td>${project?.customer || 'ООО «СеверЗастрой»'}</td>
    </tr>
    <tr>
      <td class="meta-label">Генеральный подрядчик:</td>
      <td>${project?.generalContractor || 'АО «ГлавСпецСтрой»'}</td>
    </tr>
    <tr>
      <td class="meta-label">Лицо, осуществляющее строительство (Подрядчик):</td>
      <td><strong>${project?.subcontractor || 'ООО «ЭлектроМонтажСтрой»'}</strong></td>
    </tr>
    <tr>
      <td class="meta-label">Лицо, осуществляющее строительный контроль:</td>
      <td>${project?.techSupervision || 'ООО «ТехСтройКонтроль»'}</td>
    </tr>
  </table>

  <p><strong>Дата составления:</strong> «${new Date().getDate()}» ${new Date().toLocaleString('ru', { month: 'long' })} ${new Date().getFullYear()} г.</p>

  <p><strong>Комиссия в составе представителей:</strong></p>
  <p>1. Представителя застройщика (технадзора): <u>Инженер технадзора Смирнов А.В.</u></p>
  <p>2. Представителя лица, осуществляющего строительство: <u>${act.createdByPto || 'Инженер ПТО'}</u></p>

  <p>произвела осмотр работ, выполненных <u>ООО «ЭлектроМонтажСтрой»</u></p>

  <div class="section-title">1. К освидетельствованию предъявлены следующие работы:</div>
  <div class="field-box"><strong>${act.title}</strong> (${act.block_name || 'Блок А'}, ${act.floor_name || '4 этаж'}, ${act.zone_name || 'Стояк СТ-1'})</div>

  <div class="section-title">2. Работы выполнены по проектной документации:</div>
  <div class="field-box">Рабочая документация <strong>${act.projectCode}</strong>, ${act.projectDrawings}</div>

  <div class="section-title">3. При выполнении работ применены строительные материалы и оборудование:</div>
  <div class="field-box">${materialsListHtml}</div>

  <div class="section-title">4. Даты производства работ:</div>
  <div class="field-box">Начало работ: <strong>${act.startDate}</strong> г. &nbsp;&nbsp;&nbsp;&nbsp; Окончание работ: <strong>${act.endDate}</strong> г.</div>

  <div class="section-title">5. Решение комиссии:</div>
  <p>Работы выполнены в полном соответствии с проектной документацией, СП 76.13330.2016 «Электротехнические устройства», ПУЭ 7-е изд. и требованиями технических регламентов. На основании изложенного <strong>разрешается производство последующих работ</strong> (зашивка ГКЛ / устройство подвесных потолков / чистовая отделка).</p>

  <table class="signatures">
    <tr>
      <td>
        <p><strong>Представитель Заказчика (Технадзор):</strong></p>
        <div class="sign-line"></div>
        <div class="sign-caption">(подпись, расшифровка подписи)</div>
      </td>
      <td>
        <p><strong>Представитель Подрядчика (ЭОМ):</strong></p>
        <div class="sign-line"></div>
        <div class="sign-caption">(${act.createdByPto || 'Инженер ПТО'})</div>
      </td>
    </tr>
  </table>
</body>
</html>
  `;

  const blob = new Blob(['\ufeff' + docContent], {
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  });
  const fileName = `АОСР_${act.actNumber.replace(/[\/\\]/g, '_')}.docx`;
  downloadBlob(blob, fileName);
}

export function exportKs6aToDocx(entries: Ks6aEntry[], projectName: string = 'ЖК «Северная Звезда»'): void {
  const rowsHtml = entries.map((item, idx) => {
    const progressPct = item.projectPlannedVolume > 0
      ? Math.min(100, Math.round((item.foremanFactVolume / item.projectPlannedVolume) * 100))
      : 0;

    return `
      <tr>
        <td style="text-align: center;">${idx + 1}</td>
        <td>${item.block_name || 'Блок А'} - ${item.zone_name || item.zone_code || 'Зона'}</td>
        <td>${item.work_type_name || item.work_type_code || 'Электромонтаж'}</td>
        <td style="text-align: center;">${item.unit}</td>
        <td style="text-align: right;">${item.projectPlannedVolume}</td>
        <td style="text-align: right; font-weight: bold;">${item.foremanFactVolume}</td>
        <td style="text-align: right;">${item.ptoAosrVolume}</td>
        <td style="text-align: right; color: #047857;">${item.techsupSignedVolume}</td>
        <td style="text-align: right; font-weight: bold;">${progressPct}%</td>
      </tr>
    `;
  }).join('');

  const totalPlanned = entries.reduce((acc, curr) => acc + (curr.projectPlannedVolume || 0), 0);
  const totalFact = entries.reduce((acc, curr) => acc + (curr.foremanFactVolume || 0), 0);
  const totalAosr = entries.reduce((acc, curr) => acc + (curr.ptoAosrVolume || 0), 0);
  const totalSigned = entries.reduce((acc, curr) => acc + (curr.techsupSignedVolume || 0), 0);

  const docContent = `
<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>
<head>
  <meta charset="utf-8">
  <title>Ведомость КС-6а</title>
  <!--[if gte mso 9]>
  <xml>
    <w:WordDocument>
      <w:View>Print</w:View>
      <w:Zoom>100</w:Zoom>
      <w:DoNotOptimizeForBrowser/>
    </w:WordDocument>
  </xml>
  <![endif]-->
  <style>
    @page {
      size: A4 landscape;
      margin: 15mm;
    }
    body {
      font-family: 'Times New Roman', serif;
      font-size: 11pt;
      line-height: 1.2;
      color: #000000;
    }
    .header { text-align: center; font-weight: bold; font-size: 14pt; margin-bottom: 15pt; }
    .sub-header { text-align: center; font-size: 11pt; margin-bottom: 20pt; }
    .ledger-table { width: 100%; border-collapse: collapse; margin-top: 10pt; }
    .ledger-table th { background-color: #f1f5f9; border: 1px solid #000000; padding: 6pt; text-align: center; font-weight: bold; font-size: 10pt; }
    .ledger-table td { border: 1px solid #000000; padding: 5pt; font-size: 10pt; vertical-align: middle; }
    .total-row td { font-weight: bold; background-color: #f8fafc; }
    .signatures { margin-top: 30pt; width: 100%; border-collapse: collapse; }
    .signatures td { width: 50%; padding: 10pt; vertical-align: top; border: none; }
    .sign-line { border-bottom: 1px solid #000000; margin-top: 25pt; width: 90%; }
    .sign-caption { font-size: 8pt; text-align: center; color: #555555; margin-top: 2pt; width: 90%; }
  </style>
</head>
<body>
  <div class="header">
    ЖУРНАЛ УЧЕТА ВЫПОЛНЕННЫХ РАБОТ<br>
    (Накопительная ведомость КС-6а)
  </div>
  <div class="sub-header">
    Объект: <strong>${projectName}</strong> &nbsp;|&nbsp; Подрядная организация: <strong>ООО «ЭлектроМонтажСтрой»</strong><br>
    Дата формирования: ${new Date().toLocaleDateString('ru-RU')}
  </div>

  <table class="ledger-table">
    <thead>
      <tr>
        <th style="width: 4%;">№</th>
        <th style="width: 20%;">Зона / Захватка</th>
        <th style="width: 24%;">Вид электромонтажных работ</th>
        <th style="width: 8%;">Ед. изм.</th>
        <th style="width: 10%;">План проекта</th>
        <th style="width: 10%;">Факт прораба</th>
        <th style="width: 10%;">Оформлено в АОСР</th>
        <th style="width: 10%;">Подписано ТН</th>
        <th style="width: 4%;">%</th>
      </tr>
    </thead>
    <tbody>
      ${rowsHtml}
      <tr class="total-row">
        <td colspan="4" style="text-align: right;">ИТОГО:</td>
        <td style="text-align: right;">${totalPlanned}</td>
        <td style="text-align: right;">${totalFact}</td>
        <td style="text-align: right;">${totalAosr}</td>
        <td style="text-align: right; color: #047857;">${totalSigned}</td>
        <td style="text-align: right;">-</td>
      </tr>
    </tbody>
  </table>

  <table class="signatures">
    <tr>
      <td>
        <p><strong>Составил (Инженер ПТО):</strong></p>
        <div class="sign-line"></div>
        <div class="sign-caption">(подпись, расшифровка)</div>
      </td>
      <td>
        <p><strong>Проверил (Главный инженер):</strong></p>
        <div class="sign-line"></div>
        <div class="sign-caption">(подпись, расшифровка)</div>
      </td>
    </tr>
  </table>
</body>
</html>
  `;

  const blob = new Blob(['\ufeff' + docContent], {
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  });
  const fileName = `КС6а_Ведомость_${new Date().toISOString().split('T')[0]}.docx`;
  downloadBlob(blob, fileName);
}

function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
